export default "__VITE_ASSET__C0rXNrgS__"